/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-18 17:44:35
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-01-30 13:40:01
 * @FilePath: /unifyxp-v2-store-portal/src/components/Card/SeparatedContentCard/index.tsx
 */
import React from 'react';

import css from './css.less';

import { ArrowRightOutlined, InfoCircleFilled } from '@ant-design/icons';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import Dot from 'src/constrains/DotsMenuDrop';

const SeparatedContentCard = (props) => {
  const { titleColor, err, title, onClick, dotsFunctions, content, disable } =
    props;
  const _onClick = (e) => {
    if (onClick) {
      onClick(e, disable);
    }
  };
  return (
    <div className={`${css.container} ${disable ? css.disableContainer : ''}`}>
      <div className={css.topContainer}>
        <div className={css.textContainer}>
          <div
            className={`${css.timeText} ${disable ? css.disableText : ''}`}
            {...(titleColor ? { style: { color: titleColor } } : {})}>
            <NoWrapContainer>
              <GlobalTooltip title={title}>{title}</GlobalTooltip>
            </NoWrapContainer>
          </div>
        </div>
        {err && (
          <div className={css.errorContainer}>
            <InfoCircleFilled className={css.error} />
          </div>
        )}

        <div className={css.moreActionContainer}>
          {dotsFunctions && <Dot options={dotsFunctions || []} />}
        </div>

        <div className={css.arrowContainer}>
          {!disable && (
            <ArrowRightOutlined className={css.gotoIcon} onClick={_onClick} />
          )}
        </div>
      </div>
      <div className={css.contentContainer}>
        <div className={css.textContainer} onClick={_onClick}>
          <div className={css.text}>
            <NoWrapContainer>
              <GlobalTooltip title={content}>{content}</GlobalTooltip>
            </NoWrapContainer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SeparatedContentCard;
